import { Injectable } from "@angular/core";
import {
    LINKS_IMAGES_REPRESENTATION,
    OSC_IMAGES_REPRESENTATION,
    TOPOLOGY_SETTINGS
} from "../models/diagram.constants";
import { CircuitElementType, DiagramLegendGroup } from "../models/diagram.models";

/**
 * Classe responsável pela legenda do diagrama de circuitos DWDM.
 */
@Injectable({
    providedIn: "root"
})
export class DwdmCircuitDiagramLegendService {

    private readonly ACTIVE_KEY = "dwdm.circuit.diagram.legend.active";
    private readonly INACTIVE_KEY = "dwdm.circuit.diagram.legend.inactive";
    private readonly AVAILABLE_KEY = "dwdm.circuit.diagram.legend.available";

    retrieveDiagramLegend(): Map<CircuitElementType, DiagramLegendGroup> {
        const legendMap = new Map<CircuitElementType, DiagramLegendGroup>();

        legendMap.set(CircuitElementType.TRANSPONDER, this.getTransponderLegendData());
        legendMap.set(CircuitElementType.MUX, this.gtMuxDemuxLegendData());
        legendMap.set(CircuitElementType.AMPLIFIER, this.getAmplifierLegendData());
        legendMap.set(CircuitElementType.LINK, this.getLinkLegendData());
        legendMap.set(CircuitElementType.OSC, this.getOscLegendData());

        return legendMap;
    }

    private getTransponderLegendData() {
        const customStyle = "background-size: contain; width: 28px; height: 25px;";
        return {
            title: "dwdm.circuit.diagram.legend.transponder",
            items: [
                {
                    imagePath: TOPOLOGY_SETTINGS.TRANSPONDER.PRE_CONFIGURED.imagePath,
                    customStyle,
                    labelKey: this.ACTIVE_KEY
                },
                {
                    imagePath: TOPOLOGY_SETTINGS.TRANSPONDER.INITIAL.imagePath,
                    customStyle,
                    labelKey: this.INACTIVE_KEY
                },
                {
                    imagePath: TOPOLOGY_SETTINGS.TRANSPONDER.NOT_CONFIGURED.imagePath,
                    customStyle,
                    labelKey: this.AVAILABLE_KEY
                },
                {
                    imagePath: TOPOLOGY_SETTINGS.TRANSPONDER.CONFIGURED["4x100GbE"].imagePath,
                    customStyle,
                    labelKey: "dwdm.circuit.diagram.legend.transponder.configured.multirate"
                }
            ]
        };
    }

    private gtMuxDemuxLegendData() {
        const customStyle = "background-size: contain; width: 7px; height: 60px;";
        return {
            title: "dwdm.circuit.diagram.legend.muxDemux",
            items: [
                {
                    imagePath: TOPOLOGY_SETTINGS.MUX.CONFIGURED.imagePath,
                    customStyle,
                    labelKey: this.ACTIVE_KEY
                },
                {
                    imagePath: TOPOLOGY_SETTINGS.MUX.INITIAL.imagePath,
                    customStyle,
                    labelKey: this.INACTIVE_KEY
                },
                {
                    imagePath: TOPOLOGY_SETTINGS.MUX.NOT_CONFIGURED.imagePath,
                    customStyle,
                    labelKey: this.AVAILABLE_KEY
                }
            ]
        };
    }

    private getAmplifierLegendData() {
        const customStyle = "background-size: contain; height: 22px; width: 14px;";
        return {
            title: "dwdm.circuit.diagram.legend.amplifier",
            items: [
                {
                    imagePath: TOPOLOGY_SETTINGS.AMPLIFIER.BOOSTER.CONFIGURED.imagePath,
                    customStyle,
                    labelKey: "dwdm.circuit.diagram.legend.amplifier.booster.active"
                },
                {
                    imagePath: TOPOLOGY_SETTINGS.AMPLIFIER.PRE_AMP.CONFIGURED.imagePath,
                    customStyle,
                    labelKey: "dwdm.circuit.diagram.legend.amplifier.preamp.active"
                },
                {
                    imagePath: TOPOLOGY_SETTINGS.AMPLIFIER.BOOSTER.INITIAL.imagePath,
                    customStyle,
                    labelKey: "dwdm.circuit.diagram.legend.amplifier.booster.available"
                },
                {
                    imagePath: TOPOLOGY_SETTINGS.AMPLIFIER.PRE_AMP.INITIAL.imagePath,
                    customStyle,
                    labelKey: "dwdm.circuit.diagram.legend.amplifier.preamp.available"
                }
            ]
        };
    }

    private getLinkLegendData() {
        const customStyle = "background-size: contain; width: 25px; height: 25px;";
        return {
            title: "dwdm.circuit.diagram.legend.link",
            items: [
                {
                    imagePath: LINKS_IMAGES_REPRESENTATION.INTERNAL.imagePath,
                    customStyle,
                    labelKey: "dwdm.circuit.diagram.legend.internal.link"
                },
                {
                    imagePath: LINKS_IMAGES_REPRESENTATION.EXTERNAL.NOT_CONFIGURED.imagePath,
                    customStyle,
                    labelKey: "dwdm.circuit.diagram.legend.external.link.not.configured"
                },
                {
                    imagePath: LINKS_IMAGES_REPRESENTATION.EXTERNAL.CONFIGURED.imagePath,
                    customStyle,
                    labelKey: "dwdm.circuit.diagram.legend.external.link.configured"
                }
            ]
        };
    }

    private getOscLegendData() {
        const customStyle = "background-size: contain; width: 18px; height: 20px;";
        return {
            title: "dwdm.circuit.diagram.legend.osc",
            items: [
                {
                    imagePath: OSC_IMAGES_REPRESENTATION.ACTIVE.imagePath,
                    customStyle,
                    labelKey: this.ACTIVE_KEY
                },
                {
                    imagePath: OSC_IMAGES_REPRESENTATION.INACTIVE.imagePath,
                    customStyle,
                    labelKey: this.INACTIVE_KEY
                },
                {
                    imagePath: OSC_IMAGES_REPRESENTATION.AVAILABLE.imagePath,
                    customStyle,
                    labelKey: this.AVAILABLE_KEY
                }
            ]
        };
    }
}
